module.exports = __webpack_public_path__ + "static/media/2023-SWG-Uni-Student-Offer-Mobile-450x250px.8ee2529f.jpg";